// Pointy-Top-Hexagone in Axialkoordinaten (q, r). Groesse = Radius Mitte->Ecke in Weltpixeln.
export const HEX_SIZE = 28;
const SQRT3 = Math.sqrt(3);

export function hexToPixel(q: number, r: number, size = HEX_SIZE): { x: number; y: number } {
  return { x: size * (SQRT3 * q + (SQRT3 / 2) * r), y: size * 1.5 * r };
}

export function pixelToHex(x: number, y: number, size = HEX_SIZE): { q: number; r: number } {
  const qf = ((SQRT3 / 3) * x - (1 / 3) * y) / size;
  const rf = ((2 / 3) * y) / size;
  return hexRound(qf, rf);
}

export function hexRound(qf: number, rf: number): { q: number; r: number } {
  const sf = -qf - rf;
  let q = Math.round(qf);
  let r = Math.round(rf);
  const s = Math.round(sf);
  const dq = Math.abs(q - qf);
  const dr = Math.abs(r - rf);
  const ds = Math.abs(s - sf);
  if (dq > dr && dq > ds) q = -r - s;
  else if (dr > ds) r = -q - s;
  return { q, r };
}

/** Eckpunkte eines Hexagons um (cx, cy), optional geschrumpft. */
export function hexCorners(cx: number, cy: number, size = HEX_SIZE, shrink = 1): number[] {
  const pts: number[] = [];
  for (let i = 0; i < 6; i++) {
    const a = (Math.PI / 180) * (60 * i - 30);
    pts.push(cx + size * shrink * Math.cos(a), cy + size * shrink * Math.sin(a));
  }
  return pts;
}

/** Deterministischer Hash pro Hex fuer Terrain-Variation und Dekoration. */
export function hexHash(q: number, r: number): number {
  let h = (q * 374761393 + r * 668265263) | 0;
  h = Math.imul(h ^ (h >>> 13), 1274126177);
  return (h ^ (h >>> 16)) >>> 0;
}

/** Wiesen-Toene fuer leere Hexe (dunkel, damit Felder und Stoecke herausstechen). */
export const TERRAIN_PALETTE = [0x22301a, 0x27361d, 0x1f2c18, 0x2b3a20, 0x243219];

export const FIELD_STYLE: Record<string, { fill: number; rim: number; blossom: number }> = {
  RAPESEED: { fill: 0xb8960c, rim: 0xf5d020, blossom: 0xfff3a0 },
  MEADOW: { fill: 0x4f8a1f, rim: 0x86d43a, blossom: 0xffffff },
  LINDEN: { fill: 0x6aa41e, rim: 0xb8e35a, blossom: 0xe9f7b0 },
  ORCHARD: { fill: 0xb8306e, rim: 0xf472b6, blossom: 0xffd6e8 },
  HEATHER: { fill: 0x6d28a8, rim: 0xa855f7, blossom: 0xe9d5ff },
};

export const FIELD_ICONS: Record<string, string> = {
  RAPESEED: '🌻',
  MEADOW: '🌼',
  LINDEN: '🌳',
  ORCHARD: '🍎',
  HEATHER: '🪻',
};

export const DECOR = ['🌲', '🌿', '🪨', '🌾', '🍄'];
